package music.jammers.client.shared.component.avatar.di

import music.jammers.client.shared.component.avatar.presentation.viewmodel.AvatarImageViewModel
import org.koin.core.component.KoinComponent
import org.koin.dsl.module

val avatarImageModule = module {
    factory {
        AvatarImageViewModel(
            getCurrentUserUseCase = get(),
            router = get(),
        )
    }
}

class AvatarImageDiComponent : KoinComponent {

    val viewModel: AvatarImageViewModel
        get() = getKoin().get<AvatarImageViewModel>()
}